import React, {useState} from 'react';
import classNames from 'classnames';
import {Image} from 'semantic-ui-react';

import {Button, Modal} from '@components';
import constants from '@constants';
import {Props} from './types';
import * as handlers from './handlers';
import paths from '@paths';

import './index.scss';

const Price: React.FC<Props> = props => {
  const [loading, setLoading] = useState(false);
  const [isModal, setIsModal] = useState(false);

  return (
    <div
      className={classNames('b__card-plan', [
        props.className,
        {current: props.me.id && props.option === props.me.plan},
        {enterprise: props.option === constants.PLAN.SAFETY_X},
      ])}
    >
      <div className="w__card-header">
        {props.option === constants.PLAN.FREE && (
          <div className="b__option-header">無料プラン</div>
        )}
        {props.option === constants.PLAN.SAFETY && (
          <div className="b__option-header recommend">スタンダードプラン</div>
        )}
        {props.option === constants.PLAN.SAFETY_X && (
          <div className="b__option-header">エンタープライズプラン</div>
        )}

        <div className="b__option-price">
          {props.option === constants.PLAN.FREE && (
            <div className="b__price basic">
              0<span className="unit">円/月</span>
            </div>
          )}
          {props.option === constants.PLAN.SAFETY && (
            <div className="b__price recommend">
              50<span className="unit">円/月</span>
            </div>
          )}

          {props.option === constants.PLAN.SAFETY_X && (
            <div
              className={classNames('b__price price', {
                enterprise: props.option === constants.PLAN.SAFETY_X,
              })}
            >
              応相談
            </div>
          )}

          {props.option === constants.PLAN.SAFETY_X ? null : (
            <div
              className={classNames('b__price-month', {
                recommend: props.option === constants.PLAN.SAFETY,
              })}
            >
              {props.option === constants.PLAN.SAFETY && (
                <span className="description">× 登録ユーザー数</span>
              )}
            </div>
          )}
        </div>

        <div className="b__option-count">
          <div
            className={classNames('b__count', {
              enterprise: props.option === constants.PLAN.SAFETY_X,
              recommend: props.option === constants.PLAN.SAFETY,
              basic: props.option === constants.PLAN.FREE,
            })}
          >
            登録可能人数
          </div>
          {props.option === constants.PLAN.FREE && (
            <div className="b__count-number">1,000人</div>
          )}
          {props.option === constants.PLAN.SAFETY && (
            <div className="b__count-number recommend">1,000人</div>
          )}
          {props.option === constants.PLAN.SAFETY_X && (
            <div className="b__count-number">要相談</div>
          )}
        </div>
      </div>

      <div className="w__content">
        <div className="b__check-label">
          <Image src={constants.IMAGES.CHECK_GREEN} />
          <div className="b__label">メールでの安否確認</div>
        </div>
        <div className="b__check-label">
          {props.option !== constants.PLAN.FREE && (
            <Image src={constants.IMAGES.CHECK_GREEN} />
          )}
          <div
            className={classNames('b__label', {
              enabled: props.option === constants.PLAN.FREE,
            })}
          >
            SMSでの安否確認
          </div>
        </div>
        <div className="b__check-label">
          {props.option !== constants.PLAN.FREE && (
            <Image src={constants.IMAGES.CHECK_GREEN} />
          )}
          <div
            className={classNames('b__label', {
              enabled: props.option === constants.PLAN.FREE,
            })}
          >
            CSV機能
          </div>
        </div>
        <div className="b__check-label">
          {props.option === constants.PLAN.SAFETY_X && (
            <Image src={constants.IMAGES.CHECK_GREEN} />
          )}
          <div
            className={classNames('b__label', {
              enabled:
                props.option === constants.PLAN.FREE ||
                props.option === constants.PLAN.SAFETY,
            })}
          >
            電話での安否確認
          </div>
        </div>

        <div className="b__check-label">
          {props.option === constants.PLAN.SAFETY_X && (
            <Image src={constants.IMAGES.CHECK_GREEN} />
          )}
          <div
            className={classNames('b__label', {
              enabled: props.option !== constants.PLAN.SAFETY_X,
            })}
          >
            銀行振り込み対応
          </div>
        </div>

        {!!props.me.id && (
          <div
            className={classNames('w__button', {
              disabled: props.me.plan === props.option,
            })}
          >
            <Button.Normal
              text={handlers.getLabel(props.me, props.option)}
              color="green"
              onClick={async () => {
                handlers.goConfirm(
                  props.me,
                  props.option,
                  props.history,
                  setLoading,
                  setIsModal
                );
              }}
              disabled={
                props.me.plan === props.option ||
                props.me.authLevel !== constants.AUTHORITIES.SUPER_ADMIN ||
                loading
              }
            />
          </div>
        )}
      </div>
      <Modal.Normal
        isModal={isModal}
        size="xs"
        handleCloseModal={() => {
          setIsModal(false);
        }}
        title="カード情報を登録"
        buttonText="クレジットカードを登録する"
        buttonColor="yellow"
        message={
          <div>
            スタンダードプランを利用するには、クレジットカードの登録が必要です。
            クレジットカード情報画面からカード情報を登録してください。
          </div>
        }
        onClick={() => {
          props.history.push(paths.myPage.card);
        }}
        hiddenCancelButton
      />
    </div>
  );
};

export default Price;
